module.exports = __webpack_public_path__ + "static/media/react-router.02419671.svg";